import { Briefcase, Link as LinkIcon, PlusCircle } from "@phosphor-icons/react";
import { useState } from "react";

import { ManageSubscriptionDialog } from "features/subscriptions/components";

import { LinkedInLogin } from "common/components/LinkedInLogin";
import RestrictedComponent from "common/components/RestrictedComponent";
import { SplitButton } from "common/components/SplitButton";
import { Button } from "common/components/ui/Button";
import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { getWhitelabelCustomization } from "common/helpers/utils";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import BrandedLoginUrl from "./BrandedLoginUrl";

export default function AddAccount({ size }: { size: "sm" | "md" }) {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(false);
  const [action, setAction] = useState<"brandedLogin" | "login" | "rental">(
    null,
  );
  const { permissions, agency_subscription_status } =
    useSelectedWorkspaceContext();

  function closeModal() {
    setIsOpen(false);
  }

  const dropdownMenuItems = [
    {
      label: "Connect via link",
      icon: LinkIcon,
      onSelect: () => {
        setAction("brandedLogin");
        setIsOpen(true);
      },
    },
  ];
  if (!isDesktop && permissions.includes("billing_full")) {
    dropdownMenuItems.push({
      label: "Rent avatars",
      icon: Briefcase,
      onSelect: () => {
        setAction("rental");
        setIsOpen(true);
      },
    });
  }

  const commonButtonProps = {
    size,
    leftIcon: <PlusCircle weight="fill" />,
    onClick: () => {
      setAction("login");
      setIsOpen(true);
    },
    children: "Add account",
    className: "only:flex-1",
  } as const;

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <RestrictedComponent visibleForPermissions={["accounts_full"]}>
      {getWhitelabelCustomization() ||
      (agency_subscription_status &&
        agency_subscription_status !== "cancelled") ? (
        <SplitButton
          {...commonButtonProps}
          dropdownMenuItems={dropdownMenuItems}
        />
      ) : (
        <Button {...commonButtonProps} />
      )}

      {action === "rental" ? (
        <ManageSubscriptionDialog
          initialState="rental"
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          mixpanelSource="upsell_seat"
        />
      ) : (
        <Component open={isOpen} onOpenChange={setIsOpen}>
          <Content size={action === "brandedLogin" ? "md" : "lg"}>
            {action === "login" ? (
              <LinkedInLogin onSuccess={closeModal} />
            ) : (
              <BrandedLoginUrl goBack={closeModal} />
            )}
          </Content>
        </Component>
      )}
    </RestrictedComponent>
  );
}
